import { DialogTitle, Typography } from "@mui/material";

export function CustomDialogTitle({ header, poName }) {
    return (
        <DialogTitle>
            {header}
            <Typography
                variant="subtitle1"
                component="p"
                color="text.primary"
                sx={{ mt: 0.5 }}
            >
                {`PO: ${poName}`}
            </Typography>
        </DialogTitle>
    )
}